<template>
    <div class="wp-block-group has-focus-10-background-color"><div class="wp-block-group__inner-container">
        <div class="wp-block-group is-style-grid-full zb-no-margin-bottom"><div class="wp-block-group__inner-container">
            <div id="zb_trustpilot-web-card-reviews_block_fde533bce355f673c2638b1ddc6446ec" class="zb-trustpilot-web-card-reviews">

                <h2 class="zb-text txt-title-md-alt  text-align-inherit has-focus-90-color">Our clients are<br class="zb-hide-on-mobile">  our priority. </h2>

                <div class="trustpilot-wrapper light"><span>Excellent
                                    <div class="fG8Fp uo4vr"><span aria-hidden="true" class="z3HNkc" aria-label="Rated 5.0 out of 5,"
                                                                   role="img"><span style="width: 100px;"></span></span></div>

                5 out of 5
                </span>
                    <div class="google-review"></div>
                </div>
                <img decoding="async" width="89px" height="65px" class="quotation-image lazyloaded" alt="Quotation Image" src="/images/quotes-campaign.svg" data-ll-status="loaded"><noscript><img decoding="async" width="89px" height='65px' class="quotation-image" alt="Quotation Image" src="https://res.cloudinary.com/zenbusiness/image/upload/v1675356173/subscriptions-tmp/quotes-campaign.svg"></noscript>
                <div class="trustpilot-card-review">
                    <p class="txt-body-sm"><h3 class="txt-title-sm txt-bold line-height-1">The service that I was looking for</h3>
                        <br><br>
                        I hired Abe to set up an LLC and apply for a trademark. He provided a great price and was incredibly helpful every step of the way. He makes time to answer any questions you may have and explains every step of the process. He utilizes Docusign and online payment to make it effortless to get you going. You don't even need to leave your house! He provided the service that I was looking for. I highly recommend him and plan on continuing to employ his services for all my future business law needs.</p>
                    <img decoding="async"
                         src="https://res.cloudinary.com/zenbusiness/q_auto,w_32/v1/shared-assets/icon/images/trustpilot-review-star-green.svg"
                         width="32" height="32" alt="" class="zenbusiness-cloudinary-image lazyloaded"
                         sizes="(max-width: 32px) 100vw, 32px"
                         srcset="/images/trustpilot-review-star-green.svg 32w"
                         data-ll-status="loaded">
                    <noscript><img decoding="async"
                                   src="/images/trustpilot-review-star-green.svg"
                                   srcset="/images/trustpilot-review-star-green.svg 32w"
                                   sizes="(max-width: 32px) 100vw, 32px" width="32" height="32" alt=""
                                   class="zenbusiness-cloudinary-image zenbusiness-cloudinary-image"/></noscript>
                    <img decoding="async"
                         src="/images/trustpilot-review-star-green.svg"
                         width="32" height="32" alt="" class="zenbusiness-cloudinary-image lazyloaded"
                         sizes="(max-width: 32px) 100vw, 32px"
                         srcset="/images/trustpilot-review-star-green.svg 32w"
                         data-ll-status="loaded">
                    <noscript><img decoding="async"
                                   src="/images/trustpilot-review-star-green.svg"
                                   srcset="/images/trustpilot-review-star-green.svg 32w"
                                   sizes="(max-width: 32px) 100vw, 32px" width="32" height="32" alt=""
                                   class="zenbusiness-cloudinary-image zenbusiness-cloudinary-image"/></noscript>
                    <img decoding="async"
                         src="/images/trustpilot-review-star-green.svg"
                         width="32" height="32" alt="" class="zenbusiness-cloudinary-image lazyloaded"
                         sizes="(max-width: 32px) 100vw, 32px"
                         srcset="/images/trustpilot-review-star-green.svg 32w"
                         data-ll-status="loaded">
                    <noscript><img decoding="async"
                                   src="/images/trustpilot-review-star-green.svg"
                                   srcset="/images/trustpilot-review-star-green.svg 32w"
                                   sizes="(max-width: 32px) 100vw, 32px" width="32" height="32" alt=""
                                   class="zenbusiness-cloudinary-image zenbusiness-cloudinary-image"/></noscript>
                    <img decoding="async"
                         src="/images/trustpilot-review-star-green.svg"
                         width="32" height="32" alt="" class="zenbusiness-cloudinary-image lazyloaded"
                         sizes="(max-width: 32px) 100vw, 32px"
                         srcset="/images/trustpilot-review-star-green.svg 32w"
                         data-ll-status="loaded">
                    <noscript><img decoding="async"
                                   src="/images/trustpilot-review-star-green.svg"
                                   srcset="/images/trustpilot-review-star-green.svg 32w"
                                   sizes="(max-width: 32px) 100vw, 32px" width="32" height="32" alt=""
                                   class="zenbusiness-cloudinary-image zenbusiness-cloudinary-image"/></noscript>
                    <img decoding="async"
                         src="/images/trustpilot-review-star-green.svg"
                         width="32" height="32" alt="" class="zenbusiness-cloudinary-image lazyloaded"
                         sizes="(max-width: 32px) 100vw, 32px"
                         srcset="/images/trustpilot-review-star-green.svg"
                         data-ll-status="loaded">
                    <noscript><img decoding="async"
                                   src="/images/trustpilot-review-star-green.svg"
                                   srcset="/images/trustpilot-review-star-green.svg 32w"
                                   sizes="(max-width: 32px) 100vw, 32px" width="32" height="32" alt=""
                                   class="zenbusiness-cloudinary-image zenbusiness-cloudinary-image"/></noscript>
                    <p class="text-body-md txt-bold">Sergey Zabarin</p>
                </div>
            </div>
        </div></div>
    </div></div>
    <div class="wp-block-group is-style-default has-focus-10-background-color has-focus-00-background-color has-background"><div class="wp-block-group__inner-container">
        <div style="height:38px" aria-hidden="true" class="wp-block-spacer zb-hide-on-mobile"></div>


        <div id="zb_carousel-feature-bar_block_8d5ce7a0a6767dc395d599b792921596" class="zb-carousel-feature-bar center has-focus-10-background-color contained">
            <div class="zb-carousel-feature-bar--carousel-heading">
                <p class="zb-text lg_txt-body-xl sm_txt-caption-lg text-align-center txt-bold has-focus-30-color">        The #1 Rated Service by        </p>

            </div>
            <div class="zb-carousel-feature-bar--carousel-container">
                <div>
                    <svg class="caret-left" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path stroke="#787878" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l6-7-6-7"></path>
                    </svg>
                </div>
                <div class="zb-carousel-feature-bar--inner-container">
                    <div class="zb-carousel-feature-bar--logo-wrapper">
                        <img decoding="async" src="/images/company-1.png" width="" height="25" alt="Forbes" class="featured-logo zenbusiness-cloudinary-image active lazyloaded" sizes="(max-width: 0px) 100vw, 0px" srcset="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-forbes-grey.svg w" data-ll-status="loaded"><noscript><img decoding="async"  src="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-forbes-grey.svg" srcset="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-forbes-grey.svg w" sizes="(max-width: 0px) 100vw, 0px" width="" height="25" alt="Forbes" class="featured-logo zenbusiness-cloudinary-image"/></noscript>				</div>
                    <div class="zb-carousel-feature-bar--logo-wrapper">
                        <img decoding="async" src="/images/company-2.png" width="" height="25" alt="Investopedia" class="featured-logo zenbusiness-cloudinary-image lazyloaded" sizes="(max-width: 0px) 100vw, 0px" srcset="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-investopedia-grey.svg w" data-ll-status="loaded"><noscript><img decoding="async"  src="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-investopedia-grey.svg" srcset="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-investopedia-grey.svg w" sizes="(max-width: 0px) 100vw, 0px" width="" height="25" alt="Investopedia" class="featured-logo zenbusiness-cloudinary-image"/></noscript>				</div>
                    <div class="zb-carousel-feature-bar--logo-wrapper">
                        <img decoding="async" src="/images/company-3.png" width="" height="25" alt="Marketwatch" class="featured-logo zenbusiness-cloudinary-image lazyloaded" sizes="(max-width: 0px) 100vw, 0px" srcset="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-marketwatch-grey.svg w" data-ll-status="loaded"><noscript><img decoding="async"  src="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-marketwatch-grey.svg" srcset="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-marketwatch-grey.svg w" sizes="(max-width: 0px) 100vw, 0px" width="" height="25" alt="Marketwatch" class="featured-logo zenbusiness-cloudinary-image"/></noscript>				</div>
                    <div class="zb-carousel-feature-bar--logo-wrapper">
                        <img decoding="async" src="/images/company-4.png" width="" height="25" alt="Nerdwallet" class="featured-logo zenbusiness-cloudinary-image lazyloaded" sizes="(max-width: 0px) 100vw, 0px" srcset="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-nerdwallet-grey.svg w" data-ll-status="loaded"><noscript><img decoding="async"  src="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-nerdwallet-grey.svg" srcset="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-nerdwallet-grey.svg w" sizes="(max-width: 0px) 100vw, 0px" width="" height="25" alt="Nerdwallet" class="featured-logo zenbusiness-cloudinary-image"/></noscript>				</div>
                    <div class="zb-carousel-feature-bar--logo-wrapper">
                        <img decoding="async" src="/images/company-5.png" width="" height="20" alt="Mark Cuban" class="featured-logo zenbusiness-cloudinary-image lazyloaded" sizes="(max-width: 0px) 100vw, 0px" srcset="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-mark-cuban-grey.svg w" data-ll-status="loaded"><noscript><img decoding="async"  src="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-mark-cuban-grey.svg" srcset="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/illustration/logo-feature-bar-mark-cuban-grey.svg w" sizes="(max-width: 0px) 100vw, 0px" width="" height="20" alt="Mark Cuban" class="featured-logo zenbusiness-cloudinary-image"/></noscript>				</div>
                </div>
                <div>
                    <svg class="caret-right" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path stroke="#787878" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l6-7-6-7"></path>
                    </svg>
                </div>
            </div>
        </div>
    </div></div>
</template>

<script>
export default {
    props: {
        list: Array
    }
}
</script>
<style scoped>
p {
    display: block;
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/assets/css/imports.css?ver=1685981523 ; media=all */
@media all{
    *{box-sizing:border-box;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(0,0,0,0);}
    div,img,p,span{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;font-weight:inherit;vertical-align:baseline;}
    img{max-width:100%;height:auto;}
    p{margin-bottom:15px;}
    .txt-body-sm,.txt-title-sm{font-family:"Inter","Trebuchet_MS",sans-serif;}
    .txt-title-md-alt{font-family:"Montserrat","Verdana",sans-serif;}
    .txt-title-md-alt{font-weight:800;}
    .txt-body-sm,.txt-title-sm{font-weight:400;}
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .txt-title-md-alt{font-size:1.5rem;line-height:1.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.25rem;line-height:1.5rem;letter-spacing:-.5px;}
        .txt-body-sm{font-size:.875rem;line-height:1.3125rem;}
    }
    @media screen and (min-width:960px){
        .txt-title-md-alt{font-size:2.25rem;line-height:2.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.75rem;line-height:2.125rem;letter-spacing:-.5px;}
        .txt-body-sm{font-size:1rem;line-height:1.5rem;}
    }
    .text-align-inherit{text-align:inherit;}
    .is-style-grid-full{max-width:1232px;margin:0 auto;padding:0 16px;display:grid;grid-template-columns:repeat(4,1fr);-moz-column-gap:16px;column-gap:16px;}
    .is-style-grid-full>*{margin-bottom:30px;grid-column:1/5;}
    .is-style-grid-full.zb-no-margin-bottom>*{margin-bottom:0;}
    @media screen and (min-width:960px){
        .is-style-grid-full{grid-template-columns:repeat(8,1fr);}
        .is-style-grid-full>*{grid-column:1/9;}
    }
    @media screen and (min-width:1280px){
        .is-style-grid-full{grid-template-columns:repeat(12,1fr);-moz-column-gap:24px;column-gap:24px;}
        .is-style-grid-full>*{grid-column:1/13;}
    }
    .txt-body-sm,.txt-title-sm{font-family:"Inter","Trebuchet_MS",sans-serif;}
    .txt-title-md-alt{font-family:"Montserrat","Verdana",sans-serif;}
    .txt-title-md-alt{font-weight:800;}
    .txt-body-sm,.txt-title-sm{font-weight:400;}
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .txt-title-md-alt{font-size:1.5rem;line-height:1.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.25rem;line-height:1.5rem;letter-spacing:-.5px;}
        .txt-body-sm{font-size:.875rem;line-height:1.3125rem;}
    }
    @media screen and (min-width:960px){
        .txt-title-md-alt{font-size:2.25rem;line-height:2.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.75rem;line-height:2.125rem;letter-spacing:-.5px;}
        .txt-body-sm{font-size:1rem;line-height:1.5rem;}
    }
    .text-align-inherit{text-align:inherit;}
    @media screen and (max-width:599px){
        .zb-hide-on-mobile{display:none;}
    }
    .zb-no-margin-bottom{margin-bottom:0;}
    .has-focus-10-background-color{background-color:#fafafa;}
    .has-focus-90-color{color:#000;}
    .zb-no-margin-bottom{margin-bottom:0;}
    .txt-body-sm,.txt-title-sm{font-family:"Inter","Trebuchet_MS",sans-serif;}
    .txt-title-md-alt{font-family:"Montserrat","Verdana",sans-serif;}
    .txt-title-md-alt{font-weight:800;}
    .txt-body-sm,.txt-title-sm{font-weight:400;}
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .txt-title-md-alt{font-size:1.5rem;line-height:1.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.25rem;line-height:1.5rem;letter-spacing:-.5px;}
        .txt-body-sm{font-size:.875rem;line-height:1.3125rem;}
    }
    @media screen and (min-width:960px){
        .txt-title-md-alt{font-size:2.25rem;line-height:2.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.75rem;line-height:2.125rem;letter-spacing:-.5px;}
        .txt-body-sm{font-size:1rem;line-height:1.5rem;}
    }
    .text-align-inherit{text-align:inherit;}
    .zb-text{width:100%;margin:0 auto;}
    .trustpilot-wrapper{display:flex;align-items:center;justify-content:center;margin:10px 0;width:-moz-fit-content;width:fit-content;background-color:#fafafa;border-radius:36px;padding:24px 36px;box-shadow:0 4px 12px rgba(0,0,0,.12);flex-wrap:wrap;}
    .trustpilot-wrapper img{margin:0 10px;}
    .trustpilot-wrapper span{display:flex;flex-shrink:0;}
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/ui-parts/blocks/trustpilot-web-card-reviews/trustpilot-web-card-reviews-rebrand.css?ver=1685981523 ; media=all */
@media all{
    .zb-trustpilot-web-card-reviews{display:grid;}
    .zb-trustpilot-web-card-reviews .trustpilot-card-review{align-self:center;padding:18px;border-radius:18px;width:90%;max-width:547px;margin:0 auto;background:#2e2e2e;background:#fff;box-shadow:0 4px 16px 2px rgba(0,0,0,.12);order:2;}
    .zb-trustpilot-web-card-reviews .quotation-image{display:none;}
    .zb-trustpilot-web-card-reviews .txt-body-sm,.zb-trustpilot-web-card-reviews .txt-title-sm{margin-bottom:18px;}
    .zb-trustpilot-web-card-reviews .zb-text{order:1;margin-bottom:24px;text-align:center;}
    .zb-trustpilot-web-card-reviews .trustpilot-wrapper{
        flex-direction: column;
        order:3;box-shadow:none;background-color:transparent;margin:10px auto;}
    @media screen and (min-width:960px){
        .zb-trustpilot-web-card-reviews{grid-template-rows:1fr;grid-template-rows:50%;grid-template-columns:repeat(2,1fr);align-items:center;-moz-column-gap:56px;column-gap:56px;position:relative;}
        .zb-trustpilot-web-card-reviews .trustpilot-card-review{padding:36px;order:1;grid-row:1/3;z-index:1;}
        .zb-trustpilot-web-card-reviews .trustpilot-card-review .txt-body-sm{text-align:left;}
        .zb-trustpilot-web-card-reviews .quotation-image{display:block;position:absolute;top:-20px;left:-40px;}
        .zb-trustpilot-web-card-reviews .zb-text{order:2;text-align:left;margin-bottom:0;font-size:2.5rem;align-self:end;}
        .zb-trustpilot-web-card-reviews .trustpilot-wrapper{grid-row:2/3;grid-column:2/3;margin:20px 0 0;padding:20px 36px 49px 0;align-self:start;}
    }
}
/*! CSS Used from: Embedded */
.wp-block-group{box-sizing:border-box;}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/assets/css/imports.css?ver=1685981523 ; media=all */
@media all{
    *{box-sizing:border-box;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(0,0,0,0);}
    div,img,p{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;font-weight:inherit;vertical-align:baseline;}
    img{max-width:100%;height:auto;}
    p{margin-bottom:15px;}
    .lg_txt-body-xl,.sm_txt-caption-lg{font-family:"Inter","Trebuchet_MS",sans-serif;}
    @media screen and (min-width:960px){
        .lg_txt-body-xl{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-caption-lg{font-weight:400;}
    }
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .sm_txt-caption-lg{font-size:.8125rem;line-height:1rem;}
    }
    @media screen and (min-width:960px){
        .lg_txt-body-xl{font-size:1.5rem;line-height:2.25rem;}
    }
    .text-align-center{text-align:center;}
    .lg_txt-body-xl,.sm_txt-caption-lg{font-family:"Inter","Trebuchet_MS",sans-serif;}
    @media screen and (min-width:960px){
        .lg_txt-body-xl{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-caption-lg{font-weight:400;}
    }
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .sm_txt-caption-lg{font-size:.8125rem;line-height:1rem;}
    }
    @media screen and (min-width:960px){
        .lg_txt-body-xl{font-size:1.5rem;line-height:2.25rem;}
    }
    .text-align-center{text-align:center;}
    @media screen and (max-width:599px){
        .zb-hide-on-mobile{display:none;}
    }
    .has-focus-00-background-color{background-color:#fff;}
    .has-focus-10-background-color{background-color:#fafafa;}
    .has-focus-30-color{color:#c7c7c7;}
    .lg_txt-body-xl,.sm_txt-caption-lg{font-family:"Inter","Trebuchet_MS",sans-serif;}
    @media screen and (min-width:960px){
        .lg_txt-body-xl{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-caption-lg{font-weight:400;}
    }
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .sm_txt-caption-lg{font-size:.8125rem;line-height:1rem;}
    }
    @media screen and (min-width:960px){
        .lg_txt-body-xl{font-size:1.5rem;line-height:2.25rem;}
    }
    .text-align-center{text-align:center;}
    .zb-text{width:100%;margin:0 auto;}
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/ui-parts/blocks/carousel-feature-bar/carousel-feature-bar-rebrand.css?ver=1685981523 ; media=all */
@media all{
    .zb-carousel-feature-bar{min-height:150px;overflow:hidden;display:flex;flex-direction:column;justify-content:center;align-items:center;}
    @media screen and (min-width:960px){
        .zb-carousel-feature-bar{width:100%;}
    }
    .zb-carousel-feature-bar .caret-left,.zb-carousel-feature-bar .caret-right{fill:none;color:#187f8b;height:25px;width:25px;cursor:pointer;}
    @media screen and (min-width:960px){
        .zb-carousel-feature-bar .caret-left,.zb-carousel-feature-bar .caret-right{display:none;}
    }
    .zb-carousel-feature-bar .caret-left{transform:rotate(180deg);}
    .zb-carousel-feature-bar .zb-carousel-feature-bar--carousel-heading{margin-bottom:20px;width:100%;}
    .zb-carousel-feature-bar .zb-carousel-feature-bar--carousel-container{display:flex;justify-content:center;align-items:center;width:90%;}
    .zb-carousel-feature-bar .zb-carousel-feature-bar--logo-wrapper{margin:0 auto;width:100%;}
    @media screen and (min-width:960px){
        .zb-carousel-feature-bar .zb-carousel-feature-bar--logo-wrapper{display:flex;justify-content:center;flex:1 1 auto;}
    }
    .zb-carousel-feature-bar .zenbusiness-cloudinary-image{display:none;height:37px;}
    @media screen and (min-width:960px){
        .zb-carousel-feature-bar .zenbusiness-cloudinary-image{display:block;}
    }
    .zb-carousel-feature-bar .zenbusiness-cloudinary-image.active{display:block;}
    @media screen and (max-width:959px){
        .zb-carousel-feature-bar .zenbusiness-cloudinary-image.active{margin:0 auto;}
    }
    .zb-carousel-feature-bar .zb-carousel-feature-bar--inner-container{width:60%;height:34px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;}
    @media screen and (min-width:960px){
        .zb-carousel-feature-bar .zb-carousel-feature-bar--inner-container{width:100%;max-width:1232px;margin:0 auto;flex-wrap:nowrap;}
    }
    .zb-carousel-feature-bar.contained .zb-carousel-feature-bar--inner-container{gap:0 48px;justify-content:center;}
    @media screen and (min-width:1280px){
        .zb-carousel-feature-bar.center{max-width:1232px;margin:0 auto;padding:0 16px;}
    }
}
.fG8Fp.uo4vr {
    margin-left: 2px;
}
/*! CSS Used from: Embedded */
.wp-block-spacer{clear:both;}
/*! CSS Used from: Embedded */
.wp-block-group{box-sizing:border-box;}

/*! CSS Used from: Embedded */
.uo4vr{color:#70757a;line-height:1.58;}
/*! CSS Used from: Embedded */
.z3HNkc{background-image:url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 23.44 19'><polygon fill='%23dadce0' points='10,15.27 16.18,19 14.54,11.97 20,7.24 12.81,6.63 10,0 7.19,6.63 0,7.24 5.46,11.97 3.82,19'/></svg>");background-repeat:repeat-x;display:inline-block;overflow:hidden;position:relative;}
.z3HNkc span{background-image:url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 23.44 19'><polygon fill='%23fbbc04' points='10,15.27 16.18,19 14.54,11.97 20,7.24 12.81,6.63 10,0 7.19,6.63 0,7.24 5.46,11.97 3.82,19'/></svg>");background-repeat:repeat-x;display:block;}

.z3HNkc, .z3HNkc span {
    background-size: 20px 21.4px;
    height: 20.4px;
    width: 100px;
}
.quotation-image {
    width: 89px;
}
.google-review {
    background: url('../../../public/images/google-review.png');
    width: 160px;
    height: 33px;
    background-size: cover;
    background-position: 0px -32px;
    display: block;
}
</style>
